export default "__VITE_PUBLIC_ASSET__3f62b401__"